<div class="inspection-dialog">

  <div class="ui-g-12 p-zero dialog-header">
    <div class="columns">
      <div class="icon pl-2">
        <div class="icon-circle ml-2"><i class="fal fa-exclamation-triangle pt-1"></i></div>
      </div>
      <div class="close">
        <i class="fal fa-times fa-sm dialog-close font-500" (click)="closeDialog(false, 'cancel')"></i>
      </div>
    </div>
  </div>

  <div class="dialog-body">
    <div class="ui-g-12 p-zero">
      <div class="columns">
        <div class="text pl-2 pb-2">
          <div class="font-18 font-bold black tml-heading">Select an inspection status <br> for the item</div>
          <div class="font-16 font-500 gray-55 tml-sub-header">Attachments and notes cannot be <br> added to undefined
            inspection <br> items</div>
        </div>
      </div>
    </div>
  </div>

  <div class="ui-g-12 p-zero dialog-footer">
    <div class="p-zero text-right float-right attendence-add-footer">

      <button id="dialog-btn-cancel" *ngIf="data?.button?.cancel?.title" (click)="closeDialog(false, 'cancel')"
        class="btn btn-white btn-border pointer btn-submit mr-2" [ngStyle]="{
          'background-color': data?.button?.cancel?.backgroundColor? data?.button?.cancel?.backgroundColor: '#ffffff',
          'color': data?.button?.cancel?.color? data?.button?.cancel?.color: '#333333'
        }">
        {{data?.button?.cancel?.title}}
      </button>

      <button id="dialog-btn-success" *ngIf="data?.button?.success?.title" (click)="closeDialog(true, 'success')"
        class="btn btn-primary btn-submit font-bold" [ngStyle]="{
          'background-color': data?.button?.success?.backgroundColor? data?.button?.success?.backgroundColor: 'var(--primary-500)',
          'color': data?.button?.success?.color? data?.button?.success?.color: '#ffffff'
        }">
        {{data?.button?.success?.title}}
      </button>

    </div>
  </div>

</div>
